import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, ClipboardList, BadgePercent } from 'lucide-react';

const tabs = [
  { to: '/', label: 'Inicio', icon: Home, end: true },
  { to: '/catalogo', label: 'Catálogo', icon: LayoutGrid },
  { to: '/pedidos', label: 'Pedidos', icon: ClipboardList },
  { to: '/promociones', label: 'Ofertas', icon: BadgePercent },
];

const BottomNav = () => (
  <nav className="fixed bottom-3 left-1/2 -translate-x-1/2 z-30 w-[calc(100%-1rem)] sm:w-[calc(100%-1.5rem)] max-w-3xl">
    <div className="bg-neutral-950/95 backdrop-blur border border-white/10 rounded-full shadow-[0_18px_40px_rgba(0,0,0,0.55)] px-1.5 py-1.5 flex items-center justify-between">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `flex-1 h-10 sm:h-11 rounded-full flex flex-col sm:flex-row items-center justify-center gap-0.5 sm:gap-2 text-[10px] sm:text-sm font-semibold transition-colors ${
              isActive ? 'bg-orange-500 text-black' : 'text-white/70 hover:text-white hover:bg-white/5'
            }`
          }
        >
          <t.icon className="w-4 h-4 sm:w-4 sm:h-4" />
          <span className="leading-none">{t.label}</span>
        </NavLink>
      ))}
    </div>
  </nav>
);

export default BottomNav;
